import { Toaster as Sonner, type ToasterProps } from 'sonner';

function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="light"
      // sonner's phone css is `left: offset; width: 100%`, which is 16px wider than the screen: a visible toast made the
      // page scroll sideways and pushed fixed sheets off the screen. `!` beats its unlayered stylesheet.
      className="toaster group max-[600px]:w-auto!"
      // bottom, never top: the top holds the header (shop switcher, search, bell) and the banners above it, whose
      // height varies. On phones lift it above the bottom tab bar and the sticky action bar of a full-height sheet.
      position="bottom-center"
      offset={24}
      mobileOffset={{ bottom: 88, left: 16, right: 16 }}
      toastOptions={{
        classNames: {
          toast: 'group toast bg-popover text-popover-foreground border-border shadow-lg',
          description: 'text-muted-foreground',
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
